/**
 * Copyright 2020 (c) Dominik Basner, Sotec GmbH (for VDW e.V.)
 * Copyright 2020 (c) Fabian Wilhelm, Sotec GmbH (for VDW e.V.)
 * Copyright 2020-2021 (c) Christian von Arnim, ISW University of Stuttgart (for umati and VDW e.V.)
 * Copyright 2021 (c) Moritz Walker, ISW University of Stuttgart (for umati and VDW e.V.)
 */
import TemplateHelper from 'utilities/TemplateHelper';
import React, { Component } from 'react';
import FrontendURLs from '../../utilities/FrontendURLs';
import URLs from '../../utilities/URLs';
import { getInfoWindow } from './CustomInfoWindow';
import { getInner } from './swInfoWindow';

export default class MachineInfoWindow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imageLink: '',
      imageLinkFallback: ''
    };
  }

  render() {
    const template = TemplateHelper.getTemplateByTypeId(this.props.TypeDefinition);

    const deviceClassVariable = {
      id: 'ddc4aaca-9595-49c0-b3bc-e39c52f20131',
      modelUri: 'http://opcfoundation.org/UA/Machinery/',
      nodeId: 'ns=1;i=6012',
      displayName: 'DeviceClass',
      variablePath: 'Data.DeviceClass',
      dataType: 'String',
      modellingRule: 'Optional',
      hasProperties: false
    };

    const defaultImagePathClassifier = template?.imagesConfig.defaultImagePathClassifierVariable
      ? TemplateHelper.getVariableValue(this.props.Data, template.imagesConfig.defaultImagePathClassifierVariable)
      : TemplateHelper.getVariableValue(this.props, deviceClassVariable);

    const imageLinkFallback = URLs.getMachineImageBucketDefault(this.props.TypeDefinition, defaultImagePathClassifier);
    const imageLink = URLs.getMachineImageBucket(this.props.ImagePath);
    const linkTarget = FrontendURLs.getMachine(this.props);
    const undefinedImagePath = this.props.ImagePath === undefined;
    const err = this.state.imageLink === imageLink && this.state.imageLinkFallback === imageLinkFallback;
    const inner = getInner(this.props.Name, this.props.onMouseLeave, err ? imageLinkFallback : imageLink, this.props.children, linkTarget, (err && !undefinedImagePath) && <div className="text-mid">404</div>);
    if (this.props.isCluster) {
      return inner;
    } else {
      return(getInfoWindow(this.props, inner));
    }
  }
}
